export function capitalizeString(str: string): string {
  if (!str || str.length === 0) return str
  return str[0].toUpperCase() + str.slice(1).toLowerCase()
}

export function transformToSelectOptions(
  arr: any[],
  valueKey: string = 'id',
  labelKey: string = 'value',
  sortBy: string | null = null,
  preserveOrigVals: boolean = false
): any[] {
  if (Array.isArray(arr)) {
    let sortedArr = arr
    if (sortBy && sortBy.length) {
      sortedArr = [...arr].sort((a, b) => {
        const aVal = a[sortBy]
        const bVal = b[sortBy]
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return aVal.toLowerCase().localeCompare(bVal.toLowerCase())
        }
        return aVal > bVal ? 1 : aVal < bVal ? -1 : 0
      })
    }
    return sortedArr.map((val) =>
      typeof val === 'string'
        ? { value: val, label: val }
        : {
            ...(preserveOrigVals ? val : {}),
            value: val[valueKey],
            label: val[labelKey]
          }
    )
  } else {
    return []
  }
}
